// deps
import React, { ReactElement, memo, useState, useCallback } from "react";

// constants
import { TEXTS } from "@payment-ui/constants/index";
import { DEFAULT_CVV_LENGTH } from "@payment-ui/constants/Card";

// styles
import { CvvContainer, CvvInput } from "./styles/CVV.styled";

interface CvvProps {
    valid: boolean;
    onChange: (value: string) => void;
    validCvvLength?: number;
    onFocus?: VoidFunction;
    autoFocus?: boolean;
    disabled?: boolean;
    "data-testid"?: string;
    showFullWidthInputButton?: boolean;
}

const onClick = (event: React.MouseEvent): void => event.stopPropagation();
const isValidNumber = (val: number): boolean => !isNaN(val);

function CVV(props: CvvProps): ReactElement {
    const { onChange, onFocus, validCvvLength = DEFAULT_CVV_LENGTH, showFullWidthInputButton = false } = props;
    const [cvv, setCvv] = useState("");

    const onCvvChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>): void => {
            const eventValue = event.target.value;
            const validCvv = isValidNumber(Number(event.target.value));
            if (validCvv) {
                setCvv(eventValue);
                onChange(eventValue);
            }
        },
        [onChange],
    );

    return (
        <CvvContainer $isFullWidth={showFullWidthInputButton} onClick={onClick}>
            <CvvInput
                $isInvalid={!props.valid}
                $isFullWidth={showFullWidthInputButton}
                type="tel"
                placeholder={TEXTS.CVV}
                onChange={onCvvChange}
                maxLength={validCvvLength}
                autoComplete="off"
                value={cvv}
                autoFocus={props.autoFocus}
                disabled={props.disabled}
                onFocus={onFocus}
                data-testid={props["data-testid"]}
                data-disable-copy-paste="true"
            />
        </CvvContainer>
    );
}

CVV.defaultProps = {
    valid: true,
};

export default memo(CVV);
